module.exports = __webpack_public_path__ + "static/36575D_3_0-5d8aa2910e2d849ce11678ea115af8db.ttf";